import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  outline: none;
  width: 100%;
`;

export const Label = styled.span`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
  letter-spacing: 0.2px;
`;

type FieldParams = {
  toClipboard?: boolean;
  error?: boolean;
  required?: boolean;
};

export const Field = styled.input<FieldParams>`
  display: block;
  width: 100%;
  height: 2.75rem;
  padding: 0 0.875rem;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  color: ${({ theme }) => theme.colors.title};
  background-color: ${({ theme }) => theme.colors.background};
  border: 1.5px solid ${({ theme, error }) =>
    error ? theme.colors.error : theme.colors.border};
  border-radius: ${({ theme }) => theme.sizes.borderRadius};
  transition: border-color ${({ theme }) => theme.transitions.fast},
              box-shadow ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grayScale.variation4};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.grayScale.variation5};
  }

  &:focus:not(:read-only) {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: ${({ theme }) => theme.shadows.focus};
    background-color: ${({ theme }) => theme.colors.background};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.surfaceHover};
  }

  &[type='checkbox'] {
    width: auto;
    height: auto;
    cursor: pointer;
  }
`;

export const FieldArea = styled.textarea<FieldParams>`
  display: block;
  width: 100%;
  min-height: 6rem;
  padding: 0.75rem 0.875rem;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  color: ${({ theme }) => theme.colors.title};
  background-color: ${({ theme }) => theme.colors.background};
  border: 1.5px solid ${({ theme, error }) =>
    error ? theme.colors.error : theme.colors.border};
  border-radius: ${({ theme }) => theme.sizes.borderRadius};
  resize: vertical;
  transition: border-color ${({ theme }) => theme.transitions.fast},
              box-shadow ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grayScale.variation4};
  }

  &:focus:not(:read-only) {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }
`;
